<template>
  <div>
    <!-- Footer -->
    <div class="dashboard-footer-spacer"></div>
    <div class="small-footer margin-top-15">
      <div class="small-footer-copyrights">
        © 2019 <strong>Hireo</strong>. All Rights Reserved.
      </div>
      <ul class="footer-social-links">
        <li>
          <a href="#" title="Facebook" data-tippy-placement="top">
            <i class="icon-brand-facebook-f"></i>
          </a>
        </li>
        <li>
          <a href="#" title="Twitter" data-tippy-placement="top">
            <i class="icon-brand-twitter"></i>
          </a>
        </li>
        <li>
          <a href="#" title="Google Plus" data-tippy-placement="top">
            <i class="icon-brand-google-plus-g"></i>
          </a>
        </li>
        <li>
          <a href="#" title="LinkedIn" data-tippy-placement="top">
            <i class="icon-brand-linkedin-in"></i>
          </a>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
    <!-- Footer / End -->
  </div>
</template>

<script>
  export default {
    name: 'AppFooter',
  };
</script>

<style></style>
